export default {"src":"/_next/static/image/public/images/flags/flag_389.6cba77c2de6d4e4b1e063a5d3eb21afd.svg","height":16,"width":24};